export const dbTable = {
  head: ["TRAVEL DATE", "FROM  >   TO", "DISTRUPTION TYPE"],
  body: [
    {
      date: "21/2/2021",
      fromTo: "Dubai (DUX) > Los Angleses (LA)",
      type: "-",
      status: "New",
      id: "01",
    },
    {
      date: "19/2/2021",
      fromTo: "London UK (LUK) > Islamabad (ISB)",
      type: "-",
      status: "Closed",
      id: "02",
    },
    {
      date: "19/2/2021",
      fromTo: "Dubai (DUX) > Los Angleses (LA)",
      type: "Cancelled",
      status: "Info Required",
      id: "02",
    },
    {
      date: "21/2/2021",
      fromTo: "London UK (LUK) > Islamabad (ISB)",
      type: "Delayed",
      status: "Expired",
      id: "03",
    },
  ],
};

export const travelBookingTable = {
  head: [
    "TRAVEL DATE",
    "FROM  >   TO",
    "TRAVEL MODE",
    "TRANSPORT OPERATOR",
    "DISTRUPTION TYPE",
    "Delay",
  ],
  body: [
    {
      date: "21/2/2021",
      fromTo: "Dubai(DUX)  >  Las angleses(LA)",
      mode: "Rail",
      operate: "Delta Air Lines",
      type: "Cancelled",
      delay: "15 Mins",
      status: "Info required",
      id: "01",
    },
    {
      date: "21/2/2021",
      fromTo: "Dubai(DUX)  >  Las angleses(LA)",
      mode: "Flight",
      operate: "Delta Air Lines",
      type: "Cancelled",
      delay: "1 Day",
      status: "Info required",
      id: "02",
    },
    {
      date: "21/2/2021",
      fromTo: "Dubai(DUX)  >  Las angleses(LA)",
      mode: "Rail",
      operate: "Delta Air Lines",
      type: "Cancelled",
      delay: "15 Mins",
      status: "Info required",
      id: "03",
    },
    {
      date: "21/2/2021",
      fromTo: "Dubai(DUX)  >  Las angleses(LA)",
      mode: "Rail",
      operate: "Delta Air Lines",
      type: "Cancelled",
      delay: "15 Mins",
      status: "Info required",
      id: "04",
    },
    {
      date: "21/2/2021",
      fromTo: "Dubai(DUX)  >  Las angleses(LA)",
      mode: "Flight",
      operate: "Delta Air Lines",
      type: "Cancelled",
      delay: "1 Day",
      status: "Info required",
      id: "05",
    },
    {
      date: "21/2/2021",
      fromTo: "Dubai(DUX)  >  Las angleses(LA)",
      mode: "Rail",
      operate: "Delta Air Lines",
      type: "Cancelled",
      delay: "15 Mins",
      status: "Info required",
      id: "06",
    },
    {
      date: "21/2/2021",
      fromTo: "Dubai(DUX)  >  Las angleses(LA)",
      mode: "Rail",
      operate: "Delta Air Lines",
      type: "Cancelled",
      delay: "15 Mins",
      status: "Info required",
      id: "07",
    },
    {
      date: "21/2/2021",
      fromTo: "Dubai(DUX)  >  Las angleses(LA)",
      mode: "Flight",
      operate: "Delta Air Lines",
      type: "Cancelled",
      delay: "1 Day",
      status: "Info required",
      id: "08",
    },
    {
      date: "21/2/2021",
      fromTo: "Dubai(DUX)  >  Las angleses(LA)",
      mode: "Rail",
      operate: "Delta Air Lines",
      type: "Cancelled",
      delay: "15 Mins",
      status: "Info required",
      id: "09",
    },
    {
      date: "21/2/2021",
      fromTo: "Dubai(DUX)  >  Las angleses(LA)",
      mode: "Rail",
      operate: "Delta Air Lines",
      type: "Cancelled",
      delay: "15 Mins",
      status: "Info required",
      id: "07",
    },
    {
      date: "21/2/2021",
      fromTo: "Dubai(DUX)  >  Las angleses(LA)",
      mode: "Flight",
      operate: "Delta Air Lines",
      type: "Cancelled",
      delay: "1 Day",
      status: "Info required",
      id: "08",
    },
    {
      date: "21/2/2021",
      fromTo: "Dubai(DUX)  >  Las angleses(LA)",
      mode: "Rail",
      operate: "Delta Air Lines",
      type: "Cancelled",
      delay: "15 Mins",
      status: "Info required",
      id: "09",
    },
  ],
};

export const accountActivityTable = {
  head: [" DATE", "TIME", "ACTIVITY TYPE", "IP ADDRESS"],
  body: [
    {
      date: "21/2/2021",
      time: "5:00 PM",
      type: "Password  Changed",
      ip: "192.16.100.204",
      title:'ACTIVITY DETAIL',
      id: "01",
      activityType:'Lorem ipsum dolor sit amet, consetetur sadipscing elitr,',
      para: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor",
    },
    {
      date: "15/5/2019",
      time: "7:00 PM",
      type: "Password  Changed",
      ip: "192.16.100.204",
      title:'ACTIVITY DETAIL',
      id: "02",
      activityType:'Lorem ipsum dolor sit amet, consetetur sadipscing elitr,',
      para: "Lorem  labore et dolore magna aliquyam erat sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor",
    },
    {
      date: "4/12/2020",
      time: "2:00 PM",
      type: "Password  Changed",
      ip: "192.16.100.204",
      title:'ACTIVITY DETAIL',
      id: "03",
      activityType:'Lorem ipsum dolor sit amet, consetetur sadipscing elitr,',
      para: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor",
    },
    {
      date: "4/12/2020",
      time: "2:00 PM",
      type: "Password  Changed",
      ip: "192.16.100.204",
      title:'ACTIVITY DETAIL',
      id: "04",
      activityType:'Lorem ipsum dolor sit amet, consetetur sadipscing elitr,',
      para: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor",
    },
    {
      date: "4/12/2020",
      time: "2:00 PM",
      type: "Password  Changed",
      ip: "192.16.100.204",
      title:'ACTIVITY DETAIL',
      id: "05",
      activityType:'Lorem ipsum dolor sit amet, consetetur sadipscing elitr,',
      para: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor",
    },
    {
      date: "4/12/2020",
      time: "2:00 PM",
      type: "Password  Changed",
      ip: "192.16.100.204",
      title:'ACTIVITY DETAIL',
      id: "06",
      activityType:'Lorem ipsum dolor sit amet, consetetur sadipscing elitr,',
      para: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor",
    },
    {
      date: "4/12/2020",
      time: "2:00 PM",
      type: "Password  Changed",
      ip: "192.16.100.204",
      title:'ACTIVITY DETAIL',
      id: "07",
      activityType:'Lorem ipsum dolor sit amet, consetetur sadipscing elitr,',
      para: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor",
    },
    {
      date: "4/12/2020",
      time: "2:00 PM",
      type: "Password  Changed",
      ip: "192.16.100.204",
      id: "08",
      title:'ACTIVITY DETAIL',
      activityType:'Lorem ipsum dolor sit amet, consetetur sadipscing elitr,',
      para: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor",
    },
  ],
};


export const notifications = [
  {
    date: "4/12/2020",
    time: "12:00 PM",
    id: "01",
    title:'Message Title one',
    msg: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam",
  },
  {
    date: "14/1/2010",
    time: "9:00 PM",
    id: "21",
    title:'Message Title two',
    msg: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam",
  },
  {
    date: "4/2/2021",
    time: "5:00 PM",
    id: "03",
    title:'Message Title three',
    msg: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam",
  },
  {
    date: "4/12/2020",
    time: "2:00 PM",
    id: "04",
    title:'Message Title four',
    msg: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam",
  },
  {
    date: "4/12/2020",
    time: "22:00 PM",
    id: "05",
    title:'Message Title five',
    msg: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam",
  },
]